export default {
  state: {
    progress: false,
    login_modal: false,
    confirm_modal: false,
    forgot_password_modal: false,
  },
  mutations: {
    toggle(state, toggleType) {
      state[toggleType] = !state[toggleType];
    },
    setToggle(state, data) {
      state[data.type] = data.bool;
    },
  },
  actions: {
    toggle({ commit }, toggleType) {
      commit('toggle', toggleType);
    },
    setToggle({ commit }, data) {
      commit('setToggle', data);
    },
  },
};
